/* OVELA STUDIO · Ajustes 19 oct
   1 · Ficha: cada foto pertenece al color de la primera foto de su bloque
       (la imagen de variante es la primera foto de cada color; las siguientes se muestran con ella).
   2 · Ficha: aviso discreto bajo el pago en un clic si aún no hay talla.
   3 · Reseñas: 7 en móvil (carrusel horizontal) y "Ver más reseñas" añade otras 7 (6 y 6 en ordenador). */
(function () {
  'use strict';

  var CSV_URL = 'https://cdn.shopify.com/s/files/1/0983/8143/1108/files/resenas10.csv?v=1792827487';
  var MOBILE = 640;

  function perPage() {
    return window.innerWidth <= MOBILE ? 7 : 6;
  }

  /* ===================================================
     1 · GALERÍA POR COLOR
     =================================================== */
  function initGalleryGroups() {
    var root = document.getElementById('ovela-p');
    if (!root || root.dataset.ovelaGroups === 'true') return;
    root.dataset.ovelaGroups = 'true';

    var thumbs = root.querySelectorAll('.ov-thumb');
    var group = '';
    var changed = false;
    thumbs.forEach(function (t) {
      var own = (t.dataset.variantIds || '').trim();
      if (own) {
        group = own;
      } else if (group) {
        t.dataset.variantIds = group;
        changed = true;
      }
    });

    /* Vuelve a filtrar la galería con el color que ya está elegido */
    if (changed) {
      var active = root.querySelector('.ov-color.active');
      if (active) {
        active.click();
      } else {
        thumbs.forEach(function (t) { t.classList.remove('ov-hidden'); });
      }
    }
  }

  /* ===================================================
     2 · AVISO DEL PAGO EN UN CLIC
     =================================================== */
  function initAccelHint() {
    var lock = document.getElementById('ovelaPdpAccelLock');
    var box = document.getElementById('ovelaPdpAccel');
    var root = document.getElementById('ovela-p');
    if (!lock || !box || lock.dataset.ovelaHint === 'true') return;
    lock.dataset.ovelaHint = 'true';

    var hint = document.createElement('p');
    hint.className = 'ovela-pdp-accel-hint';
    hint.setAttribute('role', 'status');
    hint.hidden = true;
    box.appendChild(hint);

    lock.addEventListener('click', function () {
      /* ovela-mentor.js deja en el botón el motivo (sin talla o talla agotada) */
      hint.textContent = (lock.textContent || '').trim() || 'Elige tu talla para pagar en un clic';
      hint.hidden = false;
    });

    if (root) {
      root.addEventListener('click', function () {
        setTimeout(function () {
          if (!box.classList.contains('is-locked')) hint.hidden = true;
        }, 0);
      });
    }
  }

  /* ===================================================
     3 · RESEÑAS (sustituye al listado anterior: 4 en móvil)
     =================================================== */
  function normalizar(t) {
    return String(t || '').toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }

  function escapeHtml(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[m];
    });
  }

  function estrellas(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += i <= Number(n) ? '★' : '☆';
    return s;
  }

  function parseCSV(text) {
    text = String(text || '').replace(/^﻿/, '');
    var first = text.split(/\r?\n/)[0] || '';
    var d = (first.match(/;/g) || []).length > (first.match(/,/g) || []).length ? ';' : ',';
    var rows = [], row = [], cell = '', q = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i], n = text[i + 1];
      if (c === '"') {
        if (q && n === '"') { cell += '"'; i++; } else { q = !q; }
      } else if (c === d && !q) {
        row.push(cell); cell = '';
      } else if ((c === '\n' || c === '\r') && !q) {
        if (c === '\r' && n === '\n') i++;
        row.push(cell); rows.push(row); row = []; cell = '';
      } else {
        cell += c;
      }
    }
    if (cell !== '' || row.length) { row.push(cell); rows.push(row); }
    if (!rows.length) return [];
    var h = rows[0].map(function (x) { return String(x || '').trim().replace(/^﻿/, ''); });
    var out = [];
    for (var r = 1; r < rows.length; r++) {
      if (!rows[r] || !rows[r].length) continue;
      var o = {};
      h.forEach(function (k, j) { o[k] = (rows[r][j] || '').trim(); });
      out.push(o);
    }
    return out;
  }

  function initReviews() {
    var root = document.querySelector('[data-ovela-reviews]');
    if (!root || root.dataset.initialized === 'true') return;
    /* Marca la sección para que el script antiguo no la vuelva a pintar */
    root.dataset.initialized = 'true';

    var productTitle = root.dataset.product || '';
    var key = 'ovela_reviews_' + normalizar(productTitle);
    var list = root.querySelector('[data-list]');
    var more = root.querySelector('[data-more]');
    var score = root.querySelector('[data-score]');
    var form = root.querySelector('[data-form]');
    var open = root.querySelector('[data-open]');
    var close = root.querySelector('[data-close]');
    var reviewForm = root.querySelector('[data-review-form]');
    var nameInput = root.querySelector('[data-name]');
    var textInput = root.querySelector('[data-text]');
    var help = root.querySelector('[data-help]');
    var error = root.querySelector('[data-error]');
    var success = root.querySelector('[data-success]');
    var starButtons = root.querySelectorAll('.ovela-review-star-btn');
    if (!list || !more || !score) return;

    var rating = 0;
    var imported = [];
    var saved = [];
    var visible = perPage();

    function loadSaved() {
      try {
        saved = JSON.parse(localStorage.getItem(key) || '[]');
        if (!Array.isArray(saved)) saved = [];
      } catch (e) {
        saved = [];
      }
    }

    function all() {
      var p = normalizar(productTitle);
      return imported.filter(function (r) { return normalizar(r.product) === p; }).concat(saved);
    }

    function renderScore(reviews) {
      if (!reviews.length) { score.innerHTML = ''; return; }
      var media = (reviews.reduce(function (t, r) { return t + Number(r.rating); }, 0) / reviews.length)
        .toFixed(1).replace('.', ',');
      score.innerHTML = '<span class="ovela-reviews-stars">★★★★★</span><span>' + media + ' / 5 · ' +
        reviews.length + ' reseña' + (reviews.length !== 1 ? 's' : '') + '</span>';
    }

    function render() {
      var reviews = all();
      list.innerHTML = '';
      renderScore(reviews);
      if (!reviews.length) {
        list.innerHTML = '<div class="ovela-review-empty"><strong>Todavía no hay reseñas</strong>' +
          '<small>Sé la primera en compartir tu experiencia.</small></div>';
        more.style.display = 'none';
        return;
      }
      reviews.slice(0, visible).forEach(function (r) {
        var card = document.createElement('article');
        card.className = 'ovela-review-card';
        card.innerHTML =
          '<div class="ovela-review-rating" aria-label="' + escapeHtml(r.rating) + ' de 5 estrellas">' + estrellas(r.rating) + '</div>' +
          '<p class="ovela-review-text">“' + escapeHtml(r.text) + '”</p>' +
          '<div class="ovela-review-bottom"><p class="ovela-review-name">' + escapeHtml(r.name) + '</p>' +
          '<span class="ovela-review-verified">✓ Compra verificada</span></div>';
        list.appendChild(card);
      });
      more.style.display = reviews.length > visible ? 'block' : 'none';
    }

    fetch(CSV_URL, { cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('CSV');
        return res.text();
      })
      .then(function (csv) {
        imported = parseCSV(csv).map(function (r) {
          return {
            product: (r['Producto'] || '').trim(),
            name: (r['Nombre (PLACEHOLDER)'] || '').trim(),
            text: (r['Reseña (PLACEHOLDER)'] || '').trim(),
            rating: parseInt(r['Estrellas'], 10) || 0
          };
        }).filter(function (r) {
          return r.product && r.name && r.text && r.rating >= 3 && r.rating <= 5;
        });
        loadSaved();
        render();
      })
      .catch(function () {
        loadSaved();
        render();
      });

    more.addEventListener('click', function () {
      var firstNew = visible;
      visible += perPage();
      render();
      var card = list.children[firstNew];
      /* En móvil las reseñas se pasan de lado: lleva el carrusel a la primera reseña nueva */
      if (card && list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: card.offsetLeft - list.offsetLeft, behavior: 'smooth' });
      }
    });

    if (open && form) {
      open.addEventListener('click', function () {
        form.classList.add('open');
        setTimeout(function () { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
      });
    }
    if (close && form) {
      close.addEventListener('click', function () { form.classList.remove('open'); });
    }

    function resetStars() {
      rating = 0;
      starButtons.forEach(function (s) { s.classList.remove('selected'); });
      if (help) help.textContent = 'Selecciona tu valoración.';
    }

    starButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        rating = Number(b.dataset.rating);
        starButtons.forEach(function (s) {
          s.classList.toggle('selected', Number(s.dataset.rating) <= rating);
        });
        if (help) {
          help.textContent = rating <= 2
            ? 'Tu valoración será recibida, pero las reseñas de 1 o 2 estrellas no se publican.'
            : rating + ' de 5 estrellas seleccionadas.';
        }
      });
    });

    if (reviewForm) {
      reviewForm.addEventListener('submit', function (e) {
        e.preventDefault();
        error.classList.remove('show');
        success.classList.remove('show');
        var name = nameInput.value.trim();
        var text = textInput.value.trim();
        function fail(msg) { error.textContent = msg; error.classList.add('show'); }
        if (!name) { fail('Introduce tu nombre.'); nameInput.focus(); return; }
        if (!rating) { fail('Selecciona una valoración de 1 a 5 estrellas.'); return; }
        if (!text) { fail('Escribe tu reseña.'); textInput.focus(); return; }

        if (rating <= 2) {
          success.textContent = 'Gracias por compartir tu experiencia con OVELA STUDIO. Hemos recibido tu valoración.';
          success.classList.add('show');
          reviewForm.reset();
          resetStars();
          return;
        }

        var nueva = { product: productTitle, name: name, text: text, rating: rating };
        try {
          var actuales = JSON.parse(localStorage.getItem(key) || '[]');
          if (!Array.isArray(actuales)) actuales = [];
          actuales.unshift(nueva);
          localStorage.setItem(key, JSON.stringify(actuales));
          saved = actuales;
        } catch (err) {
          saved = [nueva];
        }
        reviewForm.reset();
        resetStars();
        success.textContent = 'Gracias por compartir tu experiencia con OVELA STUDIO. Tu reseña se ha publicado.';
        success.classList.add('show');
        render();
        setTimeout(function () {
          success.classList.remove('show');
          form.classList.remove('open');
        }, 1800);
      });
    }
  }

  function run() {
    initReviews();
    initGalleryGroups();
    initAccelHint();
  }

  /* Se carga con "defer": el HTML ya está leído pero el script antiguo de reseñas
     todavía no ha arrancado, así que llegamos antes que él. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
